export default class MarginType {
  public static Discount = 'discount'
  public static Profit = 'profit'
  public static CustomerDiscount = 'customer_discount'
  public static Default = 'default'
}
